import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Rect } from "react-native-svg";

export const IconFormSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconFormSquare"><Rect x="3" y="3" width="18" height="18" rx="2.75" fill="currentColor"/></CentralIconBase>;
});

export default IconFormSquare;
